// extracted by mini-css-extract-plugin
export default {"section":"bX20J","sectionOpened":"Z0UlY","icon":"luwuE","header":"dlFIu","headerInner":"N_Ltr","check":"vUFhu","title":"B8lLN","inner":"XGssZ"};